export const DATA = {
  //first
  "Stationary Combustion":
    [
      { "Gaseous": "Gaseous fuels" },
      { "Liquid": "Liquid fuels" },
      { "Solid": "Solid fuels" }
    ],

  "Gaseous": [
    { "Butane": "Butane" },
    { "CNG": 'CNG' },
    { "LNG": "LNG" },
    { "LPG": "LPG" },
    { "Natural gas": "Natural gas" },
    { "Natural gas (100% mineral blend)": "Natural gas (100% mineral blend)" },
    { "Other petroleum gas": 'Other petroleum gas' },
    { "Propane": 'Propane' }
  ],


  "Butane": [{ 1: "tonnes" }, { 2: "litres" }, { 3: "kWH(Net CV)" }, { 4: "kWH (Gross CV)" }],
  1: [{ "input": 3033.38067114094 }],
  2: [{ "input": 1.74532963221477 }],
  3: [{ "input": 0.241066096644295 }],
  4: [{ "input": 0.222406004026846 }],

  "CNG": [{ 5: "tonnes" }, { 6: "litres" }, { 7: "kWH(Net CV)" }, { 8: "kWH (Gross CV)" }],
  5: [{ "input": 2562.57441073826 }],
  6: [{ "input": 0.448446530201342 }],
  7: [{ "input": 0.202671418791946 }],
  8: [{ "input": 0.182928926174497 }],

  "LNG": [{ 9: "tonnes" }, { 10: "litres" }, { 11: "kWH(Net CV)" }, { 12: "kWH (Gross CV)" }],
  9: [{ "input": 2581.98441073826 }],
  10: [{ "input": 1.16832964966443 }],
  11: [{ "input": 0.204201418791946 }],
  12: [{ "input": 0.184318926174497 }],

  "LPG": [
    { 12: "tonnes" },
    { 13: "litres" },
    { 14: "kWh (Net CV)" },
    { 15: "kWh (Gross CV)" }
  ],
  12: [{ "input": 2939.36 }],
  13: [{ "input": 1.56 }],
  14: [{ "input": 0.23 }],
  15: [{ "input": 0.21 }],

  "Natural gas": [
    { 16: "tonnes" },
    { 17: "cubic metres" },
    { 18: "kWh (Net CV)" },
    { 19: "kWh (Gross CV)" }
  ],
  16: [{ "input": 2562.57 }],
  17: [{ "input": 2.04 }],
  18: [{ "input": 0.20 }],
  19: [{ "input": 0.18 }],

  "Natural gas (100% mineral blend)": [
    { 20: "tonnes" },
    { 21: "cubic metres" },
    { 22: "kWh (Net CV)" },
    { 23: "kWh (Gross CV)" }
  ],
  20: [{ "input": 2581.98 }],
  21: [{ "input": 2.05 }],
  22: [{ "input": 0.20 }],
  23: [{ "input": 0.18 }],

  "Other petroleum gas": [
    { 24: "tonnes" },
    { 25: "litres" },
    { 26: "kWh (Net CV)" },
    { 27: "kWh (Gross CV)" }
  ],
  24: [{ "input": 2578.25 }],
  25: [{ "input": 0.94 }],
  26: [{ "input": 0.20 }],
  27: [{ "input": 0.18 }],

  "Propane": [
    { 28: "tonnes" },
    { 29: "litres" },
    { 30: "kWh (Net CV)" },
    { 31: "kWh (Gross CV)" }
  ],
  28: [{ "input": 2997.63 }],
  29: [{ "input": 1.54 }],
  30: [{ "input": 0.23 }],
  31: [{ "input": 0.21 }],



  "Liquid": [
    { "Aviation spirit": "Aviation spirit" },
    { "Aviation turbine fuel": "Aviation turbine fuel" },
    { "Burning oil": "Burning oil" },
    { "Diesel (average biofuel blend)": "Diesel (average biofuel blend)" },
    { "Diesel (100% mineral diesel)": "Diesel (100% mineral diesel)" },
    { "Fuel oil": "Fuel oil" },
    { "Gas oil": "Gas oil" },
    { "Lubricants": "Lubricants" },
    { "Lubricants": "Lubricants" },
    { "Lubricants": "Lubricants" },
    { "Lubricants": "Lubricants" },
    { "Naphtha": "Naphtha" },
    { "Naphtha": "Naphtha" },
    { "Naphtha": "Naphtha" },
    { "Naphtha": "Naphtha" },
    { "Petrol (average biofuel blend)": "Petrol (average biofuel blend)" },
    { "Petrol (100% mineral petrol)": "Petrol (100% mineral petrol)" },
    { "Processed fuel oils - residual oil": "Processed fuel oils - residual oil" },
    { "Processed fuel oils - distillate oil": "Processed fuel oils - distillate oil" },
    { "Refinery miscellaneous": "Refinery miscellaneous" },
    { "Waste oils": "Waste oils" },
    { "Waste oils": "Waste oils" },
    { "Waste oils": "Waste oils" },
    { "Waste oils": "Waste oils" },
    { "Marine gas oil": "Marine gas oil" },
    { "Marine fuel oil": "Marine fuel oil" }
  ],

  "Aviation spirit": [
    { 32: "tonnes" },
    { 33: "litres" },
    { 34: "kWh (Net CV)" },
    { 35: "kWh (Gross CV)" }
  ],
  32: [{ "input": 3193.69 }],
  33: [{ "input": 2.33 }],
  34: [{ "input": 0.26 }],
  35: [{ "input": 0.24 }],

  "Aviation turbine fuel": [
    { 36: "tonnes" },
    { 37: "litres" },
    { 38: "kWh (Net CV)" },
    { 39: "kWh (Gross CV)" }
  ],
  36: [{ "input": 3178.37 }],
  37: [{ "input": 2.54 }],
  38: [{ "input": 0.26 }],
  39: [{ "input": 0.25 }],

  "Burning oil": [
    { 40: "tonnes" },
    { 41: "litres" },
    { 42: "kWh (Net CV)" },
    { 43: "kWh (Gross CV)" }
  ],
  40: [{ "input": 3165.04 }],
  41: [{ "input": 2.54 }],
  42: [{ "input": 0.26 }],
  43: [{ "input": 0.25 }],

  "Diesel (average biofuel blend)": [
    { 44: "tonnes" },
    { 45: "litres" },
    { 46: "kWh (Net CV)" },
    { 47: "kWh (Gross CV)" }
  ],
  44: [{ "input": 3015.65 }],
  45: [{ "input": 2.51 }],
  46: [{ "input": 0.25 }],
  47: [{ "input": 0.24 }],

  "Diesel (100% mineral diesel)": [
    { 48: "tonnes" },
    { 49: "litres" },
    { 50: "kWh (Net CV)" },
    { 51: "kWh (Gross CV)" }
  ],
  48: [{ "input": 3203.91 }],
  49: [{ "input": 2.66 }],
  50: [{ "input": 0.27 }],
  51: [{ "input": 0.25 }],

  "Fuel oil": [
    { 52: "tonnes" },
    { 53: "litres" },
    { 54: "kWh (Net CV)" },
    { 55: "kWh (Gross CV)" }
  ],
  52: [{ "input": 3228.89 }],
  53: [{ "input": 3.17 }],
  54: [{ "input": 0.29 }],
  55: [{ "input": 0.27 }],

  "Gas oil": [
    { 56: "tonnes" },
    { 57: "litres" },
    { 58: "kWh (Net CV)" },
    { 59: "kWh (Gross CV)" }
  ],
  56: [{ "input": 3226.58 }],
  57: [{ "input": 2.76 }],
  58: [{ "input": 0.27 }],
  59: [{ "input": 0.26 }],

  "Lubricants": [
    { 60: "tonnes" },
    { 61: "litres" },
    { 62: "kWh (Net CV)" },
    { 63: "kWh (Gross CV)" }
  ],
  60: [{ "input": 3181.00 }],
  61: [{ "input": 2.75 }],
  62: [{ "input": 0.28 }],
  63: [{ "input": 0.26 }],

  "Naphtha": [
    { 64: "tonnes" },
    { 65: "litres" },
    { 66: "kWh (Net CV)" },
    { 67: "kWh (Gross CV)" }
  ],
  64: [{ "input": 3142.38 }],
  65: [{ "input": 2.12 }],
  66: [{ "input": 0.25 }],
  67: [{ "input": 0.24 }],

  "Petrol (average biofuel blend)": [
    { 68: "tonnes" },
    { 69: "litres" },
    { 70: "kWh (Net CV)" },
    { 71: "kWh (Gross CV)" }
  ],
  68: [{ "input": 2806.66 }],
  69: [{ "input": 2.10 }],
  70: [{ "input": 0.23 }],
  71: [{ "input": 0.22 }],

  "Petrol (100% mineral petrol)": [
    { 72: "tonnes" },
    { 73: "litres" },
    { 74: "kWh (Net CV)" },
    { 75: "kWh (Gross CV)" }
  ],
  72: [{ "input": 3154.08 }],
  73: [{ "input": 2.35 }],
  74: [{ "input": 0.25 }],
  75: [{ "input": 0.24 }],

  "Processed fuel oils - residual oil": [
    { 76: "tonnes" },
    { 77: "litres" },
    { 78: "kWh (Net CV)" },
    { 79: "kWh (Gross CV)" }
  ],
  76: [{ "input": 3228.89 }],
  77: [{ "input": 3.17 }],
  78: [{ "input": 0.29 }],
  79: [{ "input": 0.27 }],

  "Processed fuel oils - distillate oil": [
    { 80: "tonnes" },
    { 81: "litres" },
    { 82: "kWh (Net CV)" },
    { 83: "kWh (Gross CV)" }
  ],
  80: [{ "input": 3226.58 }],
  81: [{ "input": 2.76 }],
  82: [{ "input": 0.27 }],
  83: [{ "input": 0.26 }],

  "Refinery miscellaneous": [
    { 84: "tonnes" },
    { 85: "litres" },
    { 86: "kWh (Net CV)" },
    { 87: "kWh (Gross CV)" }
  ],
  84: [{ "input": 2944.32 }],
  86: [{ "input": 0.26 }],
  87: [{ "input": 0.25 }],

  "Waste oils": [
    { 88: "tonnes" },
    { 89: "litres" },
    { 90: "kWh (Net CV)" },
    { 91: "kWh (Gross CV)" }
  ],
  88: [{ "input": 3219.38 }],
  89: [{ "input": 2.75 }],
  90: [{ "input": 0.27 }],
  91: [{ "input": 0.26 }],

  "Marine gas oil": [
    { 92: "tonnes" },
    { 93: "litres" },
    { 94: "kWh (Net CV)" },
    { 95: "kWh (Gross CV)" }
  ],
  92: [{ "input": 3245.30 }],
  93: [{ "input": 2.77 }],
  94: [{ "input": 0.27 }],
  95: [{ "input": 0.26 }],

  "Marine fuel oil": [
    { 96: "tonnes" },
    { 97: "litres" },
    { 98: "kWh (Net CV)" },
    { 99: "kWh (Gross CV)" }
  ],
  96: [{ "input": 3154.75 }],
  97: [{ "input": 3.10 }],
  98: [{ "input": 0.28 }],
  99: [{ "input": 0.26 }],

  // Solid fuels


  "Solid Fuels": [
    { "Coal (industrial)": "Coal (industrial)" },
    { "Coal (electricity generation)": "Coal (electricity generation)" },
    { "Coal (domestic)": "Coal (domestic)" },
    { "Coking coal": "Coking coal" },
    { "Petroleum coke": "Petroleum coke" },
    { "Coal (electricity generation - home produced coal only)": "Coal (electricity generation - home produced coal only)" }
  ],

  "Coal (industrial)": [
    { 100: "tonnes" },
    { 101: "kWh (Net CV)" },
    { 102: "kWh (Gross CV)" }
  ],
  100: [{ "input": 2396.48 }],
  101: [{ "input": 0.34 }],
  102: [{ "input": 0.32 }],

  "Coal (electricity generation)": [
    { 103: "tonnes" },
    { 104: "kWh (Net CV)" },
    { 105: "kWh (Gross CV)" }
  ],
  103: [{ "input": 2199.33 }],
  104: [{ "input": 0.33 }],
  105: [{ "input": 0.32 }],

  "Coal (domestic)": [
    { 106: "tonnes" },
    { 107: "kWh (Net CV)" },
    { 108: "kWh (Gross CV)" }
  ],
  106: [{ "input": 2904.95 }],
  107: [{ "input": 0.37 }],
  108: [{ "input": 0.35 }],

  "Coking coal": [
    { 109: "tonnes" },
    { 110: "kWh (Net CV)" },
    { 111: "kWh (Gross CV)" }
  ],
  109: [{ "input": 3164.65 }],
  110: [{ "input": 0.38 }],
  111: [{ "input": 0.36 }],

  "Petroleum coke": [
    { 112: "tonnes" },
    { 113: "kWh (Net CV)" },
    { 114: "kWh (Gross CV)" }
  ],
  112: [{ "input": 3386.57 }],
  113: [{ "input": 0.36 }],
  114: [{ "input": 0.34 }],

  "Coal (electricity generation - home produced coal only)": [
    { 115: "tonnes" },
    { 116: "kWh (Net CV)" },
    { 117: "kWh (Gross CV)" }
  ],
  115: [{ "input": 2195.90 }],
  116: [{ "input": 0.33 }],
  117: [{ "input": 0.32 }],




  //second part

  "Mobile Combustion": [
    { "LPG": "LPG" },
    { "Other petroleum gas": "Other petroleum gas" },
    { "Gasoline (average biofuel blend)": "Gasoline (average biofuel blend)" },
    { "Gasoline (100% mineral)": "Gasoline (100% mineral)" },
    { "Diesel (average biofuel blend)": "Diesel (average biofuel blend)" },
    { "Diesel (100% mineral diesel)": "Diesel (100% mineral diesel)" }
  ],
  "LPG": [
    { 118: "tonnes" },
    { 119: "litres" },
    { 120: "kWh (Net CV)" },
    { 121: "kWh (Gross CV)" }
  ],
  118: [{ "input": 2939.36 }],
  119: [{ "input": 1.56 }],
  120: [{ "input": 0.23 }],
  121: [{ "input": 0.21 }],

  "Other petroleum gas": [
    { 122: "tonnes" },
    { 123: "litres" },
    { 124: "kWh (Net CV)" },
    { 125: "kWh (Gross CV)" }
  ],
  122: [{ "input": 2578.25 }],
  123: [{ "input": 0.94 }],
  124: [{ "input": 0.20 }],
  125: [{ "input": 0.18 }],

  "Gasoline (average biofuel blend)": [
    { 126: "tonnes" },
    { 127: "litres" },
    { 128: "kWh (Net CV)" },
    { 129: "kWh (Gross CV)" }
  ],
  126: [{ "input": 2806.66 }],
  127: [{ "input": 2.10 }],
  128: [{ "input": 0.23 }],
  129: [{ "input": 0.22 }],

  "Gasoline (100% mineral)": [
    { 130: "tonnes" },
    { 131: "litres" },
    { 132: "kWh (Net CV)" },
    { 133: "kWh (Gross CV)" }
  ],
  130: [{ "input": 3154.08 }],
  131: [{ "input": 2.35 }],
  132: [{ "input": 0.25 }],
  133: [{ "input": 0.24 }],

  "Diesel (average biofuel blend)": [
    { 134: "tonnes" },
    { 135: "litres" },
    { 136: "kWh (Net CV)" },
    { 137: "kWh (Gross CV)" }
  ],
  134: [{ "input": 3015.65 }],
  135: [{ "input": 2.51 }],
  136: [{ "input": 0.25 }],
  137: [{ "input": 0.24 }],

  "Diesel (100% mineral diesel)": [
    { 138: "tonnes" },
    { 139: "litres" },
    { 140: "kWh (Net CV)" },
    { 141: "kWh (Gross CV)" }
  ],
  138: [{ "input": 3203.91 }],
  139: [{ "input": 2.66 }],
  140: [{ "input": 0.27 }],
  141: [{ "input": 0.25 }],



  //third part
  "Fugitive Emissions": [
    { "Carbon dioxide": "Carbon dioxide" },
    { "Methane": "Methane" },
    { "Nitrous oxide": "Nitrous oxide" },
    { "Hydro Fluoro Carbons": "Hydro Fluoro Carbons" },
    { "Petro Fluoro Carbon": "Petro Fluoro Carbon" },
    { "Sulphur hexafluoride (SF6)": "Sulphur hexafluoride (SF6)" },
    { "Nitrogen trifluoride": "Nitrogen trifluoride" },
    { "Blends": "Blends" }
  ],

  "Hydro Fluoro Carbons": [
    { "HFC-23": "HFC-23" },
    { "HFC-32": "HFC-32" },
    { "HFC-41": "HFC-41" },
    { "HFC-125": "HFC-125" },
    { "HFC-134": "HFC-134" },
    { "HFC-134a": "HFC-134a" },
    { "HFC-143": "HFC-143" },
    { "HFC-143a": "HFC-143a" },
    { "HFC-152a": "HFC-152a" },
    { "HFC-227ea": "HFC-227ea" },
    { "HFC-236fa": "HFC-236fa" },
    { "HFC-245fa": "HFC-245fa" },
    { "HFC-43-I0mee": "HFC-43-I0mee" },
    { "HFC-152": "HFC-152" },
    { "HFC-161": "HFC-161" },
    { "HFC-236cb": "HFC-236cb" },
    { "HFC-236ea": "HFC-236ea" },
    { "HFC-245ca": "HFC-245ca" },
    { "HFC-365mfc": "HFC-365mfc" }
  ],


  "HFC-23": [
    { 142: "kg" }
  ],
  142: [{ "input": 12400 }],

  "HFC-32": [
    { 143: "kg" }
  ],
  143: [{ "input": 677 }],

  "HFC-41": [
    { 144: "kg" }
  ],
  144: [{ "input": 116 }],

  "HFC-125": [
    { 145: "kg" }
  ],
  145: [{ "input": 3170 }],

  "HFC-134": [
    { 146: "kg" }
  ],
  146: [{ "input": 1120 }],

  "HFC-134a": [
    { 147: "kg" }
  ],
  147: [{ "input": 1300 }],

  "HFC-143": [
    { 148: "kg" }
  ],
  148: [{ "input": 328 }],

  "HFC-143a": [
    { 149: "kg" }
  ],
  149: [{ "input": 4800 }],

  "HFC-152a": [
    { 150: "kg" }
  ],
  150: [{ "input": 138 }],

  "HFC-227ea": [
    { 151: "kg" }
  ],
  151: [{ "input": 3350 }],

  "HFC-236fa": [
    { 152: "kg" }
  ],
  152: [{ "input": 8060 }],

  "HFC-245fa": [
    { 153: "kg" }
  ],
  153: [{ "input": 858 }],

  "HFC-43-I0mee": [
    { 154: "kg" }
  ],
  154: [{ "input": 1650 }],

  "HFC-152": [
    { 155: "kg" }
  ],
  155: [{ "input": 16 }],

  "HFC-161": [
    { 156: "kg" }
  ],
  156: [{ "input": 4 }],

  "HFC-236cb": [
    { 157: "kg" }
  ],
  157: [{ "input": 1210 }],

  "HFC-236ea": [
    { 158: "kg" }
  ],
  158: [{ "input": 1330 }],

  "HFC-245ca": [
    { 159: "kg" }
  ],
  159: [{ "input": 716 }],

  "HFC-365mfc": [
    { 160: "kg" }
  ],
  160: [{ "input": 804 }],



  "Petro Fluoro Carbons": [
    { "Perfluoromethane (PFC-14)": "Perfluoromethane (PFC-14)" },
    { "Perfluoroethane (PFC-116)": "Perfluoroethane (PFC-116)" },
    { "Perfluoropropane (PFC-218)": "Perfluoropropane (PFC-218)" },
    { "Perfluorocyclobutane (PFC-318)": "Perfluorocyclobutane (PFC-318)" },
    { "Perfluorobutane (PFC-3-1-10)": "Perfluorobutane (PFC-3-1-10)" },
    { "Perfluoropentane (PFC-4-1-12)": "Perfluoropentane (PFC-4-1-12)" },
    { "Perfluorohexane (PFC-5-1-14)": "Perfluorohexane (PFC-5-1-14)" },
    { "PFC-9-1-18": "PFC-9-1-18" },
    { "Perfluorocyclopropane": "Perfluorocyclopropane" }
  ],
  "Perfluoromethane (PFC-14)": [
    { 161: "kg" }
  ],
  161: [{ "input": 6630 }],

  "Perfluoroethane (PFC-116)": [
    { 162: "kg" }
  ],
  162: [{ "input": 11100 }],

  "Perfluoropropane (PFC-218)": [
    { 163: "kg" }
  ],
  163: [{ "input": 8900 }],

  "Perfluorocyclobutane (PFC-318)": [
    { 164: "kg" }
  ],
  164: [{ "input": 9540 }],

  "Perfluorobutane (PFC-3-1-10)": [
    { 165: "kg" }
  ],
  165: [{ "input": 9200 }],

  "Perfluoropentane (PFC-4-1-12)": [
    { 166: "kg" }
  ],
  166: [{ "input": 8550 }],

  "Perfluorohexane (PFC-5-1-14)": [
    { 167: "kg" }
  ],
  167: [{ "input": 7910 }],

  "PFC-9-1-18": [
    { 168: "kg" }
  ],
  168: [{ "input": 7190 }],

  "Perfluorocyclopropane": [
    { 169: "kg" }
  ],
  169: [{ "input": 9200 }],



  "Blends": [
    { "R401A": "R401A" },
    { "R401B": "R401B" },
    { "R401C": "R401C" },
    { "R402A": "R402A" },
    { "R402B": "R402B" },
    { "R403A": "R403A" },
    { "R403B": "R403B" },
    { "R404A": "R404A" },
    { "R405A": "R405A" },
    { "R406A": "R406A" },
    { "R407A": "R407A" },
    { "R407B": "R407B" },
    { "R407C": "R407C" },
    { "R407D": "R407D" },
    { "R407E": "R407E" },
    { "R407F": "R407F" },
    { "R408A": "R408A" },
    { "R409A": "R409A" },
    { "R409B": "R409B" },
    { "R410A": "R410A" },
    { "R410B": "R410B" },
    { "R411A": "R411A" },
    { "R411B": "R411B" },
    { "R412A": "R412A" },
    { "R413A": "R413A" },
    { "R414A": "R414A" },
    { "R414B": "R414B" },
    { "R415A": "R415A" },
    { "R415B": "R415B" },
    { "R416A": "R416A" },
    { "R417A": "R417A" },
    { "R417B": "R417B" },
    { "R417C": "R417C" },
    { "R418A": "R418A" },
    { "R419A": "R419A" },
    { "R419B": "R419B" },
    { "R420A": "R420A" },
    { "R421A": "R421A" },
    { "R421B": "R421B" },
    { "R422A": "R422A" },
    { "R422B": "R422B" },
    { "R422C": "R422C" },
    { "R422D": "R422D" },
    { "R422E": "R422E" },
    { "R423A": "R423A" },
    { "R424A": "R424A" },
    { "R425A": "R425A" },
    { "R426A": "R426A" },
    { "R427A": "R427A" },
    { "R428A": "R428A" },
    { "R429A": "R429A" },
    { "R430A": "R430A" },
    { "R431A": "R431A" },
    { "R432A": "R432A" },
    { "R433A": "R433A" },
    { "R433B": "R433B" },
    { "R433C": "R433C" },
    { "R434A": "R434A" },
    { "R435A": "R435A" },
    { "R436A": "R436A" },
    { "R436B": "R436B" },
    { "R437A": "R437A" },
    { "R438A": "R438A" },
    { "R439A": "R439A" },
    { "R440A": "R440A" },
    { "R441A": "R441A" },
    { "R442A": "R442A" },
    { "R443A": "R443A" },
    { "R444A": "R444A" },
    { "R445A": "R445A" },
    { "R500": "R500" },
    { "R501": "R501" },
    { "R502": "R502" },
    { "R503": "R503" },
    { "R504": "R504" },
    { "R505": "R505" },
    { "R506": "R506" },
    { "R507A": "R507A" },
    { "R508A": "R508A" },
    { "R508B": "R508B" },
    { "R509A": "R509A" },
    { "R510A": "R510A" },
    { "R511A": "R511A" },
    { "R512A": "R512A" }
  ],

  "R401A": [
    { 170: "kg" }
  ],
  170: [{ "input": 1130 }],

  "R401B": [
    { 171: "kg" }
  ],
  171: [{ "input": 1236 }],

  "R401C": [
    { 172: "kg" }
  ],
  172: [{ "input": 876 }],

  "R402A": [
    { 173: "kg" }
  ],
  173: [{ "input": 2571 }],

  "R402B": [
    { 174: "kg" }
  ],
  174: [{ "input": 2261 }],

  "R403A": [
    { 175: "kg" }
  ],
  175: [{ "input": 3100 }],

  "R403B": [
    { 176: "kg" }
  ],
  176: [{ "input": 4457 }],

  "R404A": [
    { 177: "kg" }
  ],
  177: [{ "input": 3943 }],

  "R405A": [
    { 178: "kg" }
  ],
  178: [{ "input": 4821 }],

  "R406A": [
    { 179: "kg" }
  ],
  179: [{ "input": 1780 }],

  "R407A": [
    { 180: "kg" }
  ],
  180: [{ "input": 1923 }],

  "R407B": [
    { 181: "kg" }
  ],
  181: [{ "input": 2547 }],

  "R407C": [
    { 182: "kg" }
  ],
  182: [{ "input": 1624 }],

  "R407D": [
    { 183: "kg" }
  ],
  183: [{ "input": 1487 }],

  "R407E": [
    { 184: "kg" }
  ],
  184: [{ "input": 1425 }],

  "R407F": [
    { 185: "kg" }
  ],
  185: [{ "input": 1674 }],

  "R408A": [
    { 186: "kg" }
  ],
  186: [{ "input": 3257 }],

  "R409A": [
    { 187: "kg" }
  ],
  187: [{ "input": 1485 }],

  "R409B": [
    { 188: "kg" }
  ],
  188: [{ "input": 1474 }],

  "R410A": [
    { 189: "kg" }
  ],
  189: [{ "input": 1924 }],

  "R410B": [
    { 190: "kg" }
  ],
  190: [{ "input": 2048 }],

  "R411A": [
    { 191: "kg" }
  ],
  191: [{ "input": 1555 }],

  "R411B": [
    { 192: "kg" }
  ],
  192: [{ "input": 1659 }],

  "R412A": [
    { 193: "kg" }
  ],
  193: [{ "input": 2172 }],

  "R413A": [
    { 194: "kg" }
  ],
  194: [{ "input": 1945 }],

  "R414A": [
    { 195: "kg" }
  ],
  195: [{ "input": 1375 }],

  "R414B": [
    { 196: "kg" }
  ],
  196: [{ "input": 1274 }],

  "R415A": [
    { 197: "kg" }
  ],
  197: [{ "input": 1468 }],

  "R415B": [
    { 198: "kg" }
  ],
  198: [{ "input": 544 }],

  "R416A": [
    { 199: "kg" }
  ],
  199: [{ "input": 975 }],

  "R417A": [
    { 200: "kg" }
  ],
  200: [{ "input": 2127 }],

  "R417B": [
    { 201: "kg" }
  ],
  201: [{ "input": 2742 }],

  "R417C": [
    { 202: "kg" }
  ],
  202: [{ "input": 1643 }],

  "R418A": [
    { 203: "kg" }
  ],
  203: [{ "input": 1693 }],

  "R419A": [
    { 204: "kg" }
  ],
  204: [{ "input": 2688 }],

  "R419B": [
    { 205: "kg" }
  ],
  205: [{ "input": 2161 }],

  "R420A": [
    { 206: "kg" }
  ],
  206: [{ "input": 1382 }],

  "R421A": [
    { 207: "kg" }
  ],
  207: [{ "input": 2385 }],

  "R421B": [
    { 208: "kg" }
  ],
  208: [{ "input": 2890 }],

  "R422A": [
    { 209: "kg" }
  ],
  209: [{ "input": 2847 }],

  "R422B": [
    { 210: "kg" }
  ],
  210: [{ "input": 2290 }],

  "R422C": [
    { 211: "kg" }
  ],
  211: [{ "input": 2794 }],

  "R422D": [
    { 212: "kg" }
  ],
  212: [{ "input": 2473 }],

  "R422E": [
    { 213: "kg" }
  ],
  213: [{ "input": 2350 }],

  "R423A": [
    { 214: "kg" }
  ],
  214: [{ "input": 2274 }],

  "R424A": [
    { 215: "kg" }
  ],
  215: [{ "input": 2212 }],

  "R425A": [
    { 216: "kg" }
  ],
  216: [{ "input": 1431 }],

  "R426A": [
    { 217: "kg" }
  ],
  217: [{ "input": 1371 }],

  "R427A": [
    { 218: "kg" }
  ],
  218: [{ "input": 2024 }],

  "R428A": [
    { 219: "kg" }
  ],
  219: [{ "input": 3417 }],

  "R429A": [
    { 220: "kg" }
  ],
  220: [{ "input": 15.3 }],

  "R430A": [
    { 221: "kg" }
  ],
  221: [{ "input": 106 }],

  "R431A": [
    { 222: "kg" }
  ],
  222: [{ "input": 40 }],

  "R432A": [
    { 223: "kg" }
  ],
  223: [{ "input": 1.8 }],

  "R433A": [
    { 224: "kg" }
  ],
  224: [{ "input": 0.64 }],

  "R433B": [
    { 225: "kg" }
  ],
  225: [{ "input": 0.16 }],

  "R433C": [
    { 226: "kg" }
  ],
  226: [{ "input": 0.55 }],

  "R434A": [
    { 227: "kg" }
  ],
  227: [{ "input": 3076 }],

  "R435A": [
    { 228: "kg" }
  ],
  228: [{ "input": 28.4 }],

  "R436A": [
    { 229: "kg" }
  ],
  229: [{ "input": 1.35 }],

  "R436B": [
    { 230: "kg" }
  ],
  230: [{ "input": 1.47 }],

  "R437A": [
    { 231: "kg" }
  ],
  231: [{ "input": 1639 }],

  "R438A": [
    { 232: "kg" }
  ],
  232: [{ "input": 2059 }],

  "R439A": [
    { 233: "kg" }
  ],
  233: [{ "input": 1828 }],

  "R440A": [
    { 234: "kg" }
  ],
  234: [{ "input": 156 }],

  "R441A": [
    { 235: "kg" }
  ],
  235: [{ "input": 0.23 }],

  "R442A": [
    { 236: "kg" }
  ],
  236: [{ "input": 1754 }],

  "R443A": [
    { 237: "kg" }
  ],
  237: [{ "input": 1 }],

  "R444A": [
    { 238: "kg" }
  ],
  238: [{ "input": 89 }],

  "R445A": [
    { 239: "kg" }
  ],
  239: [{ "input": 118 }],

  "R500": [
    { 240: "kg" }
  ],
  240: [{ "input": 7564 }],

  "R501": [
    { 241: "kg" }
  ],
  241: [{ "input": 3870 }],

  "R502": [
    { 242: "kg" }
  ],
  242: [{ "input": 4786 }],

  "R503": [
    { 243: "kg" }
  ],
  243: [{ "input": 13299 }],

  "R504": [
    { 244: "kg" }
  ],
  244: [{ "input": 4299 }],

  "R505": [
    { 245: "kg" }
  ],
  245: [{ "input": 7956 }],

  "R506": [
    { 246: "kg" }
  ],
  246: [{ "input": 3857 }],

  "R507A": [
    { 247: "kg" }
  ],
  247: [{ "input": 3985 }],

  "R508A": [
    { 248: "kg" }
  ],
  248: [{ "input": 11607 }],

  "R508B": [
    { 249: "kg" }
  ],
  249: [{ "input": 11698 }],

  "R509A": [
    { 250: "kg" }
  ],
  250: [{ "input": 5758 }],

  "R510A": [
    { 251: "kg" }
  ],
  251: [{ "input": 1.24 }],

  "R511A": [
    { 252: "kg" }
  ],
  252: [{ "input": 7 }],

  "R512A": [
    { 253: "kg" }
  ],
  253: [{ "input": 196 }],


  "Carbon dioxide": [{ "input": 1 }],
  "Methane": [{ "input": 28 }],
  "Nitrous oxide": [{ "input": 265 }],
  "Sulphur hexafluoride (SF6)": [{ "input": 23500 }],
  "Nitrogen trifluoride": [{ "input": 16100 }],

//Electricty and gas

"Electricty and gas": [
  {"Electricty": "Electricty"},
  {"Gas" : "Gas"},
],


"Electricty" : [
  {"EYEMALL": "EYEMALL"},
  {"ENEL ENERGIE MUNTENIA": "ENEL ENERGIE MUNTENIA"},
  {"ENGIE": "ENGIE"},
  {"HIDROELECTRICA S.A": "HIDROELECTRICA S.A"},
  {"SPEEH HIDROELECTRICA SA": "SPEEH HIDROELECTRICA SA"},
  {"ENEL": "ENEL"},
  {"SOCIETATEA ELECTRICA FURNIZARE SA": "SOCIETATEA ELECTRICA FURNIZARE SA"},
  {"NOVA POWER & GAS SRL": "NOVA POWER & GAS SRL"},
  {"EON": "EON"},
  {"PHOTOVOLTAIC GREEN PROJECT SRL": "PHOTOVOLTAIC GREEN PROJECT SRL"},
  {"CEZ VANZARE SA": "CEZ VANZARE SA"},
  {"RENOVATIO": "RENOVATIO"}
],

"EYEMALL": [
  { "input": 0.28 }
],

"ENEL ENERGIE MUNTENIA": [
  { "input": 0.14 }
],

"ENGIE": [
  { "input": 0.21 }
],

"HIDROELECTRICA S.A": [
  { "input": 0.00 }
],

"SPEEH HIDROELECTRICA SA": [
  { "input": 0.00 }
],

"ENEL": [
  { "input": 0.14 }
],

"SOCIETATEA ELECTRICA FURNIZARE SA": [
  { "input": 0.23 }
],

"NOVA POWER & GAS SRL": [
  { "input": 0.22 }
],

"EON": [
  { "input": 0.26 }
],

"PHOTOVOLTAIC GREEN PROJECT SRL": [
  { "input": 0.13 }
],

"CEZ VANZARE SA": [
  { "input": 0.22 }
],

"RENOVATIO": [
  { "input": 0.08 }
],

"Gas": [
  {"Onsite heat and steam" : "Onsite heat and steam"},
  {"District heat and steam" : "District heat and steam"},
],

"Onsite heat and steam" : [
  {"input" : 0.179646571812081},
],

"District heat and steam": [
  {"input" : 0.179646571812081}
]

}








